import React from "react";
import { useNavigate } from "react-router-dom";

const AssignmentPricing = () => {
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path);
  };
  return (
    <div id="allnotes-inner-wrapper">
      {/* Adjust the import path according to your project structure */}
      <div className="allnotes-table-wrapper">
        <h5 className="mx-4">Choose a Category</h5>
        <div className="allnotes-cards-wrapper">
          {/* School Card */}
          <div
            className="allnotes-card"
            onClick={() =>
              handleCardClick("/assignment-pricing/add-nios-assignment-pricing")
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {/* <img src={require("../../../../Images/reports.png")} alt="" /> */}
              <b>Nios Assignment (Pricing)</b>
            </div>
          </div>

          {/* College Card */}
          <div
            className="allnotes-card"
            onClick={() =>
              handleCardClick(
                "/assignment-pricing/add-university-assignment-pricing"
              )
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {/* <img src={require("../../../../Images/reports.png")} alt="" /> */}
              <b>University Assignment (Pricing)</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignmentPricing;
